import { createSlice } from "@reduxjs/toolkit";
import { deleteSurname, deleteVillage, getVillage, undoDeleteSurname, undoDeleteVillage } from "./village.api";

const surnameSlice = createSlice({
  name: "village",
  initialState: {
    village: [],
    loading: false,
    error: null,
    success: null,
    dataLimit: 0,
    currentPage: 0,
    totalPages: 0,
    totalData: 0,
  },
  reducers: {
    resetState: (state) => {
      state.loading = false;
      state.error = null;
      state.success = null;
    },
    updateLocalOrder: (state, action) => {
      state.surname.data = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(getVillage.pending, (state) => {
      state.loading = true;
      state.error = null;
    });
    builder.addCase(getVillage.fulfilled, (state, action) => {
      state.loading = false;
      state.village = action.payload;
      state.dataLimit = action.payload.meta.limit;
      state.currentPage = action.payload.meta.page;
      state.totalPages = action.payload.meta.totalPages;
      state.totalData = action.payload.meta.total;
    });
    builder.addCase(getVillage.rejected, (state, action) => {
      state.loading = false;
    });

    builder.addCase(deleteVillage.pending, (state) => {
      state.loading = true;
      state.error = null;
    });
    builder.addCase(deleteVillage.fulfilled, (state, action) => {
      const deletedId = action.payload.data._id;

      if (state.village.data) {
        state.village.data = state.village.data.filter((village) => {
          return village._id !== deletedId;
        });
        state.loading = false;
      } else {
        console.error(
          "state.village.data is not an array:",
          state.village.data
        );
      }
      state.loading = false;
    });
    builder.addCase(deleteVillage.rejected, (state, action) => {
      state.loading = false;
      state.error = action.payload;
    });

    builder.addCase(undoDeleteVillage.pending, (state) => {
      state.loading = true;
      state.error = null;
    });
    builder.addCase(undoDeleteVillage.fulfilled, (state, action) => {
      const undodeletedId = action.payload.data._id;

      if (state.village.data) {
        state.village.data = state.village.data.filter((village) => {
          return village._id !== undodeletedId;
        });
        state.loading = false;
      } else {
        console.error(
          "state.village.data is not an array:",
          state.village.data
        );
      }
      state.loading = false;
    });
    builder.addCase(undoDeleteVillage.rejected, (state, action) => {
      state.loading = false;
      state.error = action.payload;
    });
  },
});

export const { resetState } = surnameSlice.actions;
export default surnameSlice.reducer;
